import React, {useEffect, useState} from "react";
import axios from "axios";
import {useAuthDispatch, useAuthState} from "../../Context/auth-context";
import {actionTypes} from "../../Context/reducer";
import Toast from "../dashboard/Tost";
import {useMediaQuery} from "beautiful-react-hooks";
import { Link , useLocation, useNavigate } from "react-router-dom";
import SlideSHowLogin from "./SlideShowLogin";
import OtpInput from "react-otp-input";
import { Diversity1 } from "@mui/icons-material";



const BASEURL = 'https://api.sinatether.com/api/token/'

const fetchCode = async (Phone)=>{
        return axios.post( 'https://api.sinatether.com/Auth/login/',{'phone':Phone},
            {withCredentials:true})
    }

export default function Verify(){

    const location =  useLocation()
    var Phone = location.state.phone;

    const [Error,setError] = useState('')
    const [da,setda] = useState('')
    const navigate = useNavigate()
    const dispatch = useAuthDispatch();

    const [counter,setCounter] = useState(120)
    const isSmall = useMediaQuery('(max-width: 768px)')
    const[isLoading,setIsLoading] = useState(false)


    let flag=false;

    const [message,setmessage] = useState('کد تایید برای شماره شما ارسال شد')
    const [type,settype] = useState('success')

    const [Otp,setOtp] = useState('')
    const [Token,setToken] = useState('')

    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical !== null) {
    canonical.href = `https://sinatether.com/verify`;
    }


    const  fetchToken = async (Phone,Otp)=>{
        var source = ''
        var ref = ''
        if (localStorage.getItem("source"))
        {
            source =  localStorage.getItem("source")
            
        }
        if (localStorage.getItem("ref"))
        {
            ref =  localStorage.getItem("ref")
        }

        return await axios.post(BASEURL,{'phone':Phone,'password':`User${Otp}`,"source":source,"ref":ref},{
            withCredentials: true,

        })
    }



    useEffect(()=>{
        setTimeout(()=>{
            axios.get('https://api.sinatether.com/Auth/unUsableOtp/',{
                params:{'phone':Phone}
            }).then((res)=>{
            })
        },120000)
    },[])


    useEffect(()=>{



        setTimeout(()=>{
            if (counter !=0)
            {
                              setCounter(counter-1)


            }else {

                return
            }
        },1000)

    })


    function handleCheck(otp){
        setOtp(otp)

        if (otp.length == 5){
            console.log(otp)
            hanleLogin(otp)
        }
    }




    function handelError(status){
        if(!flag){
            if (da == '')
            {
                if (status == 406){
                    setError("کد تایید منقضی شده است مجددا تلاش فرمایید")
                }else {
                    setError('کد وارد شده صحیح نمیباشد')
                }

            }

        }

    }


    const  hanleLogin =async (e)=>{
        let det = 0
        if ( e.length != 5){
            e.preventDefault();
            det = 1

        }
        
        setIsLoading(true)
        dispatch({
                type:actionTypes.LOGIN_REQUEST
            })
         await fetchToken(Phone,det == 1 ? Otp : e).then(({data}) =>{

             setError('')
             flag=true
            setda(data)
            if (data['access']){

                setError('')

                flag = true;

                
                dispatch({
                type:actionTypes.LOGIN_SUCCESS,
                payload: {
                    phone: Phone,
                    name: '',
                    isEhraz: null


                }
                    
            })
                setIsLoading(false)



                if (!data['isAuth']){
                    navigate('/fast-authentication')

                }else{
                    window.location.href = "/"

                }





            }

        }).catch((e)=>{

            
            if (e.response)
            {
                handelError(e.response.status)
                setIsLoading(false)



            }

         })







    }


   function handleCode(){
        fetchCode(Phone).then((res)=>{
            if (res.status == 200)
            {
                setCounter(120)

            }
        })

    }



      
      


    return(
        <SlideSHowLogin>


            <Toast type={type} message={message}/>
            {isSmall ?

                <div className="card-size kjadhad5050">
                    <div className="container h-100">
                        <div className=" justify-content-center h-100 align-items-center mt-5">
                            <div className="">
                                <div className="mini-logo text-center my-2">
                                </div>
                                <div className="auth-form card">
                                    <div className="card-body">
                                       
                                        <div className="mybold text-dark h4 pl-1">کد تایید را وارد کنید</div>
                                        <hr className="mt-1 mb-2"/>

                                        <div className="text-muted  pl-1 text-large text-right pt-3 pb-3 ">
                                            کد تایید برای شماره 
                                            <span>{Phone}</span>
                                            پیامک شد.
                                        </div>
<Link to="/login" class="text-medium mt-2 mb-2">
    <svg id="Group_132" data-name="Group 132" xmlns="http://www.w3.org/2000/svg" width="8.983" height="8.992" viewBox="0 0 27.983 51.992">
  <path id="Path_4" data-name="Path 4" d="M14,52a2,2,0,0,0,1.41-.59l24-24a2,2,0,0,0,0-2.82l-24-24a1.994,1.994,0,1,0-2.82,2.82L35.17,26,12.59,48.59A2,2,0,0,0,14,52Z" transform="translate(-12.008 -0.008)" fill="#167f77"></path>
</svg>
    <span class="text-medium pl-1 text-price">
        اصـلاح شماره تلفن
    </span>

</Link>
                                   
                                        <form onSubmit={hanleLogin}>
                                            <div className="form-group mt-3">

                                                <div>

                                                <OtpInput
                                                            value={Otp}
                                                            type={'number'}
                                                            isInputNum = {"number"}
                                                            onChange={handleCheck}
                                                            numInputs={5}
                                                            separator={<span> </span>}
                                                            containerStyle="div-ltr"
                                                            inputStyle="otp"
                                                            
                                                        />

                                                </div>

                                                
                                           
                                                <div className={'text-medium text-danger  mt-2'}>
                                                    {Error}
                                                </div>

                                            </div>

                                            <div className="text-center">

                                              <button type="submit" className={'btn btn-primary btn-block py-2 new-btn '}>
                                              {isLoading ? 
                                                    <i className="fa fa-spinner fa-spin text-white"></i>
                                                    :

                                                 <span>تایید</span>
                                                }
                                              </button>
                                            </div>

                                        </form>
                                        <div className="new-account mt-3 d-flex justify-content-between h6 row">
                                        {counter == 0 ?
                                                <div onClick={handleCode} className={'mytext-warning text-center cur-pointer'}>دریافت مجدد کد تایید</div>
                                                :
                                                <div className={'text-center'}>
                                            <span className={'text-white'}>
                                                <span
                                                    className={' mytext-warning'}>
                                                    {counter}</span>
                                                <span className={'text-medium  pl-1'}> ثانیه مانده تا دریافت مجدد کد </span>
                                            </span>

                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                :


                                <div className="card-size">
                    <div className="container h-100">
                        <div className="row justify-content-center h-100 align-items-center">
                            <div className="">
                                <div className="mini-logo text-center my-2">

                                </div>
                                <div className="auth-form card custom-shadow">
                                    <div className="card-body">
                                        <div className="row text-center pb-5">
                                        <img className={'logo-desk-css2'} src={'./main_logo.svg'} alt={'سیناتتر'}/>

  

                                        </div>
                                        <div className="mybold text-dark h4 pl-1">کد تایید را وارد کنید</div>
                                        <hr className="mt-1 mb-2"/>

                                        <div className="text-normal text-muted  pl-1 text-large text-right pt-3 pb-3">
                                            کد تایید برای شماره 
                                            <span>{Phone}</span>
                                            پیامک شد.
                                        </div>
                                        <Link to="/login" class="text-medium mt-2 mb-2">
                                            <svg id="Group_132" data-name="Group 132" xmlns="http://www.w3.org/2000/svg" width="8.983" height="8.992" viewBox="0 0 27.983 51.992">
                                        <path id="Path_4" data-name="Path 4" d="M14,52a2,2,0,0,0,1.41-.59l24-24a2,2,0,0,0,0-2.82l-24-24a1.994,1.994,0,1,0-2.82,2.82L35.17,26,12.59,48.59A2,2,0,0,0,14,52Z" transform="translate(-12.008 -0.008)" fill="#167f77"></path>
                                        </svg>
                                            <span class="text-medium pl-1 text-price">
                                                اصلاح شماره تلفن
                                            </span>

                                        </Link>
            


                                        <form className="mt-2" onSubmit={hanleLogin}>
                                            <div className="form-group">

                                            <OtpInput
                                                            value={Otp}
                                                            type={'number'}
                                                            isInputNum = {"number"}
                                                            onChange={handleCheck}
                                                            numInputs={5}
                                                            separator={<span> </span>}
                                                            containerStyle="div-ltr"
                                                            inputStyle="otp"
                                                            
                                                        />

                                                <div className={'text-danger p mt-2'}>
                                                    {Error}
                                                </div>

                                            </div>

                                            <div className="text-center">

                                              <button type="submit" className={'btn btn-primary btn-block py-2 new-btn'}>
                                                  
                                              {isLoading ? 
                                                    <i className="fa fa-spinner fa-spin text-white"></i>
                                                    :

                                                 <span>تایید</span>
                                                }
                                                  
                                                  </button>
                                            </div>

                                        </form>
                                        <div className="new-account mt-3 d-flex justify-content-between h6 row">
                                        {counter == 0 ?
                                                <div onClick={handleCode} className={'mytext-warning text-center cur-pointer'}>دریافت مجدد کد تایید</div>
                                                :
                                                <div className={'text-center'}>
                                            <span className={'text-white'}>
                                                <span
                                                    className={' mytext-warning'}>
                                                    {counter}</span>
                                                <span className={'text-medium  pl-1'}> ثانیه مانده تا دریافت مجدد کد </span>
                                            </span>

                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            }






        </SlideSHowLogin>
      
    )
    


   
}

